import { type ReactElement } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  BomImportDropZone,
  type BomImportDropZoneLabels,
} from './BomImportDropZone'

export type BomImportUploadDialogLabels = BomImportDropZoneLabels & {
  title: string
}

type BomImportUploadDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  isBusy: boolean
  fileError: string | null
  labels: BomImportUploadDialogLabels
  onFileSelected: (file: File) => void
}

export function BomImportUploadDialog({
  open,
  onOpenChange,
  isBusy,
  fileError,
  labels,
  onFileSelected,
}: BomImportUploadDialogProps): ReactElement {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-xl'>
        <DialogHeader>
          <DialogTitle>{labels.title}</DialogTitle>
          <DialogDescription>{labels.formatsRequirement}</DialogDescription>
        </DialogHeader>
        <BomImportDropZone
          isBusy={isBusy}
          fileError={fileError}
          labels={labels}
          showFormats={false}
          onFileSelected={onFileSelected}
        />
      </DialogContent>
    </Dialog>
  )
}
